import { FC } from "react";
import { Stack } from "@mui/material";
import { MarketConnect, MarketSecurityProps } from "../../../_app/types";
import { TextFieldStyled } from "../../../_components/TextFieldStyled";
import { useTranslation } from "react-i18next";

interface ConnectAccountFormProps {
  marketConnect: MarketConnect;
  market: string;
  onChangeAccountName: (value: string) => void;
  onChangeLeverage: (value: number) => void;
  onChangeMarketSecurityProps: <K extends keyof MarketSecurityProps>(
    key: K,
    value: MarketSecurityProps[K]
  ) => void;
}

const ConnectAccountForm: FC<ConnectAccountFormProps> = ({
  marketConnect,
  onChangeAccountName,
  onChangeMarketSecurityProps,
}: ConnectAccountFormProps) => {
  const { t } = useTranslation("account");

  const marketFields = {
    AEVO: [
      { key: "aevoKey", label: t("apiKey") },
      { key: "aevoSecret", label: t("apiSecret") },
      { key: "privateKey", label: "Private key" },
    ],
    BINANCE: [
      { key: "apiKey", label: t("apiKey") },
      { key: "apiSecret", label: t("apiSecret") },
    ],
    BYBIT: [
      { key: "apiKey", label: t("apiKey") },
      { key: "apiSecret", label: t("apiSecret") },
    ],
    OKX: [
      { key: "apiKey", label: t("apiKey") },
      { key: "apiSecret", label: t("apiSecret") },
      { key: "passPhrase", label: "Pass Phrase" },
    ],
    REYA_DEX: [{ key: "privateKey", label: "Private key" }],
  };

  const fields = marketFields[marketConnect.market as keyof typeof marketFields] || [];

  if (fields.length === 0) {
    return null;
  }

  return (
    <Stack direction="column" gap="16px">
      <TextFieldStyled
        fullWidth={true}
        className={"HelperTextHalfOpacity"}
        label={t("name")}
        helperText={"Specify the name of account you want to see in this app"}
        variant="outlined"
        size="small"
        type={"text"}
        value={marketConnect.name}
        onChange={(e) => onChangeAccountName(e.target.value)}
      />

      {fields.map((field) => (
        <TextFieldStyled
          key={field.key}
          fullWidth={true}
          label={field.label}
          variant="outlined"
          size="small"
          type={"text"}
          value={marketConnect.marketSecurityProps[field.key as keyof MarketSecurityProps]}
          onChange={(e) =>
            onChangeMarketSecurityProps(field.key as keyof MarketSecurityProps, e.target.value)
          }
        />
      ))}
    </Stack>
  );
};

export default ConnectAccountForm;
